<template>
    <v-container>
        <v-row class="my-3 px-3" align="center">
            <v-col cols="12">
                <div class="headline-light secondary-color d-inline-block pointer radius-lg" v-ripple @click="goBack">
                    <v-icon class="mb-1 secondary-color">mdi-arrow-left</v-icon>
                    Volver atrás
                </div>
                <div class="display-heavy primary-color">
                    {{ title }} Sucursal
                </div>
            </v-col>
            <v-col cols="12" align="right" v-if="!!branchOfficeId">
                <v-btn class="normal-btn" color="primary" outlined large @click="showDelete" :loading="loadingDelete">
                    Eliminar Sucursal
                </v-btn>
            </v-col>
            <v-col cols="12" class="white-card px-5">
                <v-row>
                    <v-col cols="12">
                        <v-row align="center">
                            <v-col cols="12" md="8">
                                <kimsa-tabs
                                    :tabs="tabs"
                                    @change="currentTab = $event"
                                    :value="currentTab"
                                />
                            </v-col>
                            <v-col cols="12" md="4" align="right">
                                <v-btn class="normal-btn" color="skyblue" text depressed @click="save"
                                       :disabled="!valid" :loading="loadingSave">
                                    <v-icon class="mr-2">mdi-content-save-outline</v-icon>
                                    Guardar Sucursal
                                </v-btn>
                            </v-col>
                        </v-row>
                        <v-divider class="mt-1 divider-secondary"/>
                    </v-col>
                </v-row>
                <loading-spinner v-if="loading"/>
                <v-form v-model="valid" class="my-3" v-else>
                    <v-row v-show="currentTab === 'data'">
                        <!-- FIRST COLUMN -->
                        <v-col cols="12" md="4" :class="[{'border-right-secondary': !isMobile}]">
                            <v-row>
                                <v-col class="subheader-heavy primary-color">
                                    Sucursal
                                </v-col>
                                <v-col cols="12">
                                    <kimsa-text-field
                                        label="Nombre"
                                        :rules="allRules.name"
                                        @change="name = $event"
                                        :value="name"
                                        outlined dense
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <kimsa-combobox
                                        label="Region"
                                        :rules="allRules.region"
                                        @change="region = $event"
                                        :value="region"
                                        :items="regionOptions"
                                        outlined dense
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <kimsa-combobox
                                        label="Comuna"
                                        :rules="allRules.city"
                                        @change="city = $event"
                                        :value="city"
                                        :items="cityOptions"
                                        :disabled="!region"
                                        outlined dense
                                        no-object
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <kimsa-text-field
                                        label="Dirección"
                                        :rules="allRules.address"
                                        @change="address = $event"
                                        :value="address"
                                        outlined dense
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <kimsa-text-field
                                        label="Sitio Web"
                                        :rules="allRules.web"
                                        @change="web = $event"
                                        :value="web"
                                        outlined dense
                                        prefix="https://"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <kimsa-text-field
                                        label="Teléfono"
                                        :rules="allRules.phone"
                                        @change="phone = $event"
                                        :value="phone"
                                        outlined dense
                                        :prefix="phoneCode"
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <kimsa-text-field
                                        label="Horario"
                                        :rules="allRules.schedule"
                                        @change="schedule = $event"
                                        :value="schedule"
                                        outlined dense
                                    />
                                </v-col>
                                <v-col cols="12">
                                    <kimsa-text-field
                                        label="Email"
                                        :rules="allRules.email"
                                        @change="email = $event"
                                        :value="email"
                                        outlined dense
                                        inputMode="email"
                                    />
                                </v-col>
                            </v-row>
                        </v-col>
                        <!-- SECOND COLUMN -->
                        <v-col cols="12" md="8" :class="[{'border-left-secondary': !isMobile}]">
                            <div class="subheader-heavy primary-color mb-3 ml-3">
                                Examenes disponibles
                            </div>
                            <exams-picker
                                :rules="allRules.exams"
                                @change="exams = $event"
                                :value="exams"
                                return-object
                                with-all-option
                                ref="examPicker"
                            />
                        </v-col>
                    </v-row>
                    <v-row v-show="currentTab === 'exams'">
                        <v-col cols="12">
                            <kimsa-data-table
                                :headers="headers"
                                :items="examsMapped"
                            />
                        </v-col>
                    </v-row>
                </v-form>
            </v-col>
        </v-row>
        <kimsa-confirm
            ref="delete"
            title="Eliminar"
            content="¿Esta seguro que desea eliminar esta sucursal?"
            :loading="loadingDelete"
            @confirm="onConfirmDelete"
            persistent alert-mode
            no-close-on-confirm
        />
    </v-container>
</template>

<script>

import {rules} from "@/utils/Rules";
import KimsaTextField from "@/components/common/inputs/KimsaTextField";
import KimsaCombobox from "@/components/common/inputs/KimsaCombobox";
import LoadingSpinner from "@/components/common/LoadingSpinner";
import KimsaTextareaField from "@/components/common/inputs/KimsaTextareaField";
import KimsaTabs from "@/components/KimsaTabs";
import ExamsPicker from "@/components/exams/ExamsPicker";
import KimsaDataTable from "@/components/common/KimsaDataTable";
import KimsaConfirm from "@/components/common/KimsaConfirm";
import {options} from "@/utils/Options";
import httpService from "@/services/httpService";

export default {
    name: "CreateBranchOffice",
    components: {
        KimsaConfirm,
        KimsaDataTable,
        ExamsPicker,
        KimsaTabs,
        KimsaTextareaField,
        LoadingSpinner,
        KimsaCombobox,
        KimsaTextField
    },
    data() {
        return {
            loading: false,
            loadingSave: false,
            loadingDelete: false,
            valid: false,
            tabs: [
                {name: 'Datos Sucursales', value: 'data'},
                {name: 'Datos Examenes', value: 'exams'},
            ],
            currentTab: 'data',
            branchOffice: null,
            name: '',
            region: null,
            city: null,
            address: '',
            web: '',
            phone: '',
            schedule: '',
            email: '',
            exams: [],

            headers: [
                {text: 'Nombre Examen', value: 'name'},
                {text: 'Código Fonasa', value: 'code'},
                {text: 'Preparación', value: 'preparation'},
                {text: 'Domicilio', value: 'at_home', type: 'boolean'},
                {text: 'Precio Fonasa 2', value: 'price_2', type: 'money'},
                {text: 'Copago Fonasa 2', value: 'copago_2', type: 'money'},
                {text: 'Precio Fonasa 3', value: 'price_3', type: 'money'},
                {text: 'Copago Fonasa 3', value: 'copago_3', type: 'money'},
                {text: 'Particular', value: 'particular', type: 'money'},
            ],

            regionOptions: options.regionOptions,
        }
    },
    computed: {
        branchOfficeId(vm = this) {
            return vm.$route.params.branchOfficeId || null
        },
        allRules() {
            return {
                name: [rules.required, rules.minLength(this.name, 3)],
                region: [rules.required, rules.object],
                city: [rules.required],
                address: [rules.required],
                web: [],
                phone: [rules.required, rules.number],
                schedule: [rules.required],
                email: [rules.required, rules.email],
                exams: [rules.required, rules.array],
            }
        },
        title(vm = this) {
            if (!!vm.branchOfficeId) return 'Detalle de'
            return 'Crear'
        },
        cityOptions(vm = this) {
            return vm.region?.cities || []
        },
        examsMapped(vm = this) {
            return vm.exams.map(exam => ({...exam, preparation: exam.preparation.name}))
        }
    },
    async mounted() {
        const vm = this
        if (!!vm.branchOfficeId) await vm.loadBranchOffice()
    },
    methods: {
        async loadBranchOffice() {
            const vm = this
            vm.loading = true
            let response = await httpService.get(`branch-offices/${vm.branchOfficeId}`)
            vm.branchOffice = response.data.branch_office
            vm.name = vm.branchOffice.name
            vm.region = vm.regionOptions.find(op => op.name === vm.branchOffice.region)
            vm.city = vm.cityOptions.find(op => op === vm.branchOffice.city)
            vm.address = vm.branchOffice.address
            vm.web = vm.branchOffice.web
            vm.phone = vm.branchOffice.phone
            vm.schedule = vm.branchOffice.schedule
            vm.email = vm.branchOffice.email
            vm.exams = vm.branchOffice.exams
            vm.loading = false
        },
        showDelete() {
            const vm = this
            vm.$refs.delete.show()
        },
        async onConfirmDelete() {
            const vm = this
            vm.loadingDelete = true
            let response = await httpService.delete(`branch-offices/${vm.branchOfficeId}/delete`)
            vm.goBack()
            vm.loadingDelete = false
            vm.toast(response.data.message)
        },
        async save() {
            const vm = this
            !!vm.branchOfficeId ? console.log('editing') : console.log('saving')
            vm.loadingSave = true

            let payload = {
                laboratory_id: vm.currentEntityId,
                name: vm.name,
                region: vm.region.name || vm.region,
                city: vm.city,
                address: vm.address,
                web: vm.web,
                phone: vm.phone,
                schedule: vm.schedule,
                email: vm.email,
                exams: vm.getIdsFromArray(vm.exams)
            }

            console.log('payload', payload)

            let response;
            !!vm.branchOfficeId ?
                response = await httpService.put(`branch-offices/${vm.branchOfficeId}/edit`, payload) :
                response = await httpService.post('branch-offices/create', payload)

            vm.goBack()
            vm.loadingSave = false
            vm.toast(response.data.message)
        }
    },
}
</script>

<style scoped>

</style>